import React, { Component, Fragment } from 'react';
import './style.scss';
import TextInput from '../../components/text-input'
import Button from '../../components/button'
import { Link } from 'react-router-dom';
import { Close } from '@material-ui/icons';
import Axios from 'axios';

export default class SignUp extends Component {
    state = {
        FirstName: '',
        LastName: '',
        Email: '',
        Phone: '',
        Password: '',
        Add1: '',
        Add2: '',
        City: '',
        State: '',
        ZipCode: '',
        errors: {
            FirstName: false,
            LastName: false,
            Email: false,
            Phone: false,
            Password: false,
            Add1: false,
            Add2: false,
            City: false,
            State: false,
            ZipCode: false,
        },
        stage: 1
    }

    handleChange(element) {
        let { value, name } = element;
        let { errors } = this.state;

        if (!value) {
            Object.assign(errors, { [name]: true })
        } else {
            Object.assign(errors, { [name]: false })
        };

        this.setState({
            [name]: value,
            errors
        })
    }

    nextStage() {
        this.setState({
            stage: 2
        })
    }
    createAccount() {
        Axios.post('https://mascota-api.herokuapp.com/register-user', {
            "first_name": this.state.FirstName,
            "last_name": this.state.LastName,
            "email": this.state.Email,
            "password": this.state.Password,
            "primary_phone": this.state.Phone,
            "addr_1": this.state.Add1,
            "addr_2": this.state.Add2,
            "city": this.state.City,
            "state": this.state.State,
            "zip_code": this.state.ZipCode
        }, { headers: { 'Content-Type': 'application/json', } }).then(data => {
            this.props.history.push('/sign-in')
        }).catch(err => console.log(err))
    }

    render() {
        return (
            <div className='sign-up bg-image'>
                <Link to='/' className='icon-close'><Close /></Link>
                {/*  <label htmlFor="upload-profile-image" className="avatar">
                    <input type="file" id='upload-profile-image' />
                </label> */}
                <img src={require('../../images/Logo_white.svg')} alt="mascota" className="logo" />

                {this.state.stage === 1 &&
                    <Fragment>
                        <TextInput name='FirstName' label='First Name' type='text' value={this.state.FirstName} error={this.state.errors.FirstName} handleChange={this.handleChange.bind(this)} />
                        <TextInput name='LastName' label='Last Name' type='text' value={this.state.LastName} error={this.state.errors.LastName} handleChange={this.handleChange.bind(this)} />
                        <TextInput name='Email' label='Email' type='email' value={this.state.Email} error={this.state.errors.Email} handleChange={this.handleChange.bind(this)} />
                        <TextInput name='Phone' label='Phone' type='tel' value={this.state.Phone} error={this.state.errors.Phone} handleChange={this.handleChange.bind(this)} />
                        <TextInput name='Password' label='Password' type='password' value={this.state.Password} error={this.state.errors.Password} handleChange={this.handleChange.bind(this)} />
                        <div className="controls">
                            <Button text='Next' action={this.nextStage.bind(this)} />
                        </div>
                    </Fragment>
                }

                {this.state.stage === 2 &&
                    <Fragment>
                        <TextInput name='Add1' label='Address 1' type='text' value={this.state.Add1} error={this.state.errors.Add1} handleChange={this.handleChange.bind(this)} />
                        <TextInput name='Add2' label='Address 2' type='text' value={this.state.Add2} error={this.state.errors.Add2} handleChange={this.handleChange.bind(this)} />
                        <TextInput name='City' label='City' type='text' value={this.state.City} error={this.state.errors.City} handleChange={this.handleChange.bind(this)} />
                        <TextInput name='State' label='State' type='text' value={this.state.State} error={this.state.errors.State} handleChange={this.handleChange.bind(this)} />
                        <TextInput name='ZipCode' label='Zip Code' type='text' value={this.state.ZipCode} error={this.state.errors.ZipCode} handleChange={this.handleChange.bind(this)} />
                        <div className="controls">
                            <Button text='Create account' action={this.createAccount.bind(this)} />
                        </div>
                    </Fragment>
                }
            </div>
        );
    }
}